export default "__VITE_ASSET__08c4629a__"